import { Box } from '@chakra-ui/react';
import type { DashboardSection } from '../../../types';
import { BandsSection } from './BandsSection';
import { CalloutSection } from './CalloutSection';
import { CardGrid } from './CardGrid';
import { ChartSection } from './ChartSection';
import { chartOptionsFor } from './chartOptions';
import { GridSection } from './GridSection';
import { KpiTiles } from './KpiTiles';
import { ListSection } from './ListSection';
import { SectionHeader } from './SectionHeader';
import { SourcesSection } from './SourcesSection';
import { SplitBar } from './SplitBar';
import { TagsSection } from './TagsSection';

const sectionBody = (section: DashboardSection): React.ReactNode => {
  switch (section.kind) {
    case 'kpis':
      return <KpiTiles section={section} />;
    case 'split_bar':
      return <SplitBar section={section} />;
    case 'chart': {
      const options = chartOptionsFor(section);
      return options ? <ChartSection options={options} /> : null;
    }
    case 'cards':
      return <CardGrid cards={section.cards ?? []} />;
    case 'bands':
      return <BandsSection section={section} />;
    case 'tags':
      return <TagsSection section={section} />;
    case 'grid':
      return <GridSection section={section} />;
    case 'list':
      return <ListSection section={section} />;
    case 'callout':
      return <CalloutSection section={section} />;
    case 'sources':
      return <SourcesSection section={section} />;
    default:
      return null;
  }
};

export const Section = ({ section }: { section: DashboardSection }) => {
  const body = sectionBody(section);
  if (!body) return null;
  return (
    <Box>
      <SectionHeader section={section} />
      {body}
    </Box>
  );
};
